module.exports = __webpack_public_path__ + "static/media/config.ce40a73a.svg";